import { render, staticRenderFns } from "./agv-article.vue?vue&type=template&id=b5c6a966&scoped=true&lang=pug&"
import script from "./agv-article.vue?vue&type=script&lang=js&"
export * from "./agv-article.vue?vue&type=script&lang=js&"
import style0 from "./agv-article.vue?vue&type=style&index=0&id=b5c6a966&scoped=true&lang=css&"
import style1 from "./agv-article.vue?vue&type=style&index=1&id=b5c6a966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c6a966",
  null
  
)

export default component.exports